import { type FC, type PropsWithChildren, useEffect, useMemo, useTransition } from 'react';

import { AiSocket } from '../api/ai-socket';

import { AiSocketContext } from './AiSocketContext';

/** Глобальный провайдер AI-сокета. Создаёт и поддерживает соединение на уровне приложения. */
export const AiSocketProvider: FC<PropsWithChildren> = ({ children }) => {
  const aiSocket = useMemo(() => AiSocket.getInstance(), []);
  const [, startTransition] = useTransition();

  useEffect(() => {
    let isMounted = true;
    let hasReference = false;

    startTransition(async () => {
      try {
        await aiSocket.connect();
        hasReference = true;

        // Провайдер успел размонтироваться, пока шло подключение — ссылку отдаём сразу
        if (!isMounted) {
          hasReference = false;
          aiSocket.disconnect();
        }
      } catch {
        // Подключиться не удалось — ссылка не захвачена, освобождать нечего
      }
    });

    return () => {
      isMounted = false;

      // Ссылку снимаем только если подключение состоялось — иначе счётчик уйдёт в минус
      if (hasReference) {
        hasReference = false;
        aiSocket.disconnect();
      }
    };
  }, [aiSocket]);

  return <AiSocketContext.Provider value={aiSocket}>{children}</AiSocketContext.Provider>;
};
